

import { useState } from "react";
import { Pencil, Save, X } from "lucide-react";

const KeyContacts = () => {
    const [isEditing, setIsEditing] = useState(false);
    const [formData, setFormData] = useState({
        hrManager: "Rohan Patil",
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSave = () => {
        setIsEditing(false);
    };

    return (
        <div className="card">
            <div className="card-header d-flex justify-content-between align-items-center">
                <h5 className="mb-0">Key Contacts</h5>
                <div>
                    {isEditing && (
                        <button onClick={handleSave} className="btn btn-success btn-sm me-2">
                            <Save size={18} className="me-1" /> Save
                        </button>
                    )}
                    <button onClick={() => setIsEditing(!isEditing)} className="border-0 bg-transparent">
                        {isEditing ? <X className="text-danger" size={20} /> : <Pencil className="text-primary" size={20} />}
                    </button>
                </div>
            </div>

            <div className="card-block">
                <div className="row mb-3">
                    {/* HR Manager */}
                    <div className="col-lg-12 mb-3">
                        <label className="form-label">HR Manager</label>
                        {isEditing ? (
                            <select name="hrManager" className="form-control input-me f-14" value={formData.hrManager} onChange={handleChange}>
                                <option>Rohan Patil</option>
                                <option>Naresh</option>
                                <option>Mukesh Kumar</option>
                                <option>Ravi Shankar</option>
                            </select>
                        ) : (
                            <p className="mb-0 f-13">{formData.hrManager}</p>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default KeyContacts;
